/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { Image, IImageData } from '@msdyn365-commerce/core';
// import { StockCountJournalsDataActions } from '@msdyn365-commerce/retail-proxy';
import {
    IProductSpecificationProps as IProductSpecificationExtensionProps,
    IProductSpecificationConfig as IProductSpecificationExtensionConfig,
    IReassuranceItemsData as IReassuranceItemsExtensionData
} from '../definition-extensions/product-specification.ext.props.autogenerated';
import * as React from 'react';
// import axios from 'axios';
interface NutritionalData {
    label: string;
    qty1Label: string;
    qty1Unit: string;
    qty1Value: number;
    subcategory: NutritionalSubcategoryData[];
}

interface NutritionalSubcategoryData {
    label: string;
    qty1Unit: string;
    qty1Value: number;
}

/* interface ProductLabel {
    label: string;
    imgLink: string;
} */

interface ReassuranceShowType {
    title: string;
    description: string;
    image: IImageData;
}

const ProductSpecificationView: React.FC<IProductSpecificationViewProps &
    IProductSpecificationExtensionProps<IProductSpecificationViewProps> &
    IProductSpecificationExtensionConfig> = props => {
    const { ProductSpecification, productSpecificationResult } = props;
    const tags = ['Gluten free', 'Palm oil free', 'Vegan friendly', 'Light'];
    const specificationsList = ['Product description', /* 'Nutritional Values', */ 'Nutritional Values JSON', 'Ingredients'];
    const ingredientsAllAttributesList = ['Ingredients', 'Ingredients 2', 'Ingredients 3'];
    const labels = props.resources;
    // @ts-ignore
    const pTags = [];
    // @ts-ignore
    const pSpecifications = [];
    // @ts-ignore
    const ingredientsArray = [];
    var ingredientsString = '';

    const temporaryDisabled = true;

    const reassuranceItems: ReassuranceShowType[] =
        props?.config?.reassuranceItems?.map((reassurance: IReassuranceItemsExtensionData) => ({
            title: reassurance.reassuranceTitle,
            description: reassurance.reassuranceDescription,
            image: reassurance.reassuranceImage
        })) ?? [];

    const isProductAccordionOpened = props?.config?.productDescriptionAccordionOpened ?? false;

    const [accordionsState, setAccordionsState] = React.useState(isProductAccordionOpened ? 'Productdescription' : '');
    // const [fetchingLabels, setFetchingLabels] = React.useState(false);
    /* const [productLabels, setProductLabels] = React.useState(
        [{
            label: labels['product_specification_title_emea_label'] ?? "EMEA label",
            imgLink: ''
        },{
            label: labels['product_specification_title_emea_warnings'] ?? "EMEA warnings",
            imgLink: ''
        },{
            label: labels['product_specification_title_fda_label'] ?? "FDA label",
            imgLink: ''
        }]) */

    productSpecificationResult?.map(row => {
        const itemHtml = row?.props.cellData.props.dangerouslySetInnerHTML;
        if (row !== null && tags.includes(row.props.productName) && itemHtml !== undefined && itemHtml.__html === 'Yes') {
            pTags.push(row);
        }
    });
    productSpecificationResult?.map(row => {
        if (
            row !== null &&
            specificationsList.includes(row.props.productName) &&
            row.props.cellData.props.dangerouslySetInnerHTML !== undefined
        ) {
            pSpecifications.push(row);
        }
        if (
            row !== null &&
            ingredientsAllAttributesList.includes(row.props.productName) &&
            row.props.cellData.props.dangerouslySetInnerHTML !== undefined
        ) {
            ingredientsArray.push(row);
        }
    });
    // @ts-ignore
    const productSku = props.data.product.result?.ItemId;
    // @ts-ignore
    const productPrimaryImageUrl = props.data.product.result?.PrimaryImageUrl;

    // @ts-ignore
    ingredientsArray.map(row => {
        ingredientsString += row.props.cellData.props.dangerouslySetInnerHTML.__html || '';
    });

    const accordionOnClick = (accordion: string): void => {
        const accStates = accordionsState.split(',');
        if (accStates.includes(accordion)) {
            // setAccordionsState(accStates.filter(acc=>acc!==accordion).join(','));
            setAccordionsState('');
        } else {
            // setAccordionsState([...accStates, accordion].join(','));
            setAccordionsState(accordion);
        }
    };

    const isAccordionExpanded = (accordion: string): boolean => {
        const accStates = accordionsState.split(',');
        return accStates.includes(accordion);
    };

    const _renderNutritionalValues = (jData: any): JSX.Element => {
        // const jData = JSON.parse(data);
        return (
            <div className='nutritional-values-container'>
                {jData.map((row: NutritionalData) => (
                    <>
                        <div className='nutritional-values-row'>
                            <div className='nutritional-values-col'>{labels[row.label] ?? ''}</div>
                            <div className='nutritional-values-col -spacer -line'></div>
                            <div className='nutritional-values-col -pr'>{labels[row.qty1Label] ?? ''}</div>
                            <div className='nutritional-values-col -pr'>{row.qty1Value ?? ''}</div>
                            <div className='nutritional-values-col'>{row.qty1Unit ?? ''}</div>
                        </div>
                        {row.subcategory &&
                            row.subcategory.map((subRow: NutritionalSubcategoryData) => (
                                <div className='nutritional-values-row -subcategory'>
                                    <div className='nutritional-values-col -subcategory'>{labels[subRow.label] ?? ''}</div>
                                    <div className='nutritional-values-col -spacer'></div>
                                    <div className='nutritional-values-col -subcategory -pr'>{subRow.qty1Value ?? ''}</div>
                                    <div className='nutritional-values-col -subcategory'>{subRow.qty1Unit ?? ''}</div>
                                </div>
                            ))}
                    </>
                ))}
            </div>
        );
    };

    /* const _renderProductLabels = (productLabels: ProductLabel[], labels: any): JSX.Element => {
        const titleLabel = labels['product_specification_title_product_labels'] ?? 'Product labels';
        return (
            <div className="Productlabels -accordion">
                <div className="accordion-header">
                    <button type="button" onClick={() => accordionOnClick('Productlabels')}>
                        <h4>{titleLabel}</h4>
                        <div className={`accordion-button${isAccordionExpanded('Productlabels') ? ' -expanded' : ' -collapsed'}`}></div>
                    </button>
                </div>
                <div className={`content${isAccordionExpanded('Productlabels') ? ' -expanded' : ''}`}>
                    <div className="labels-container">
                        {productLabels.filter(label => label.imgLink !== '').map((row: ProductLabel) => (
                            <div className="label-row">
                                <div className="label-col">
                                    <a href={row.imgLink} target="_blank">{row.label}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    } */

    const _renderReassurance = (reassuranceItems: ReassuranceShowType[], labels: any): JSX.Element => {
        const titleLabel = labels['product_specification_title_reassurance'] ?? 'Shipments and Returns';
        return (
            <div className='Reassurance -accordion'>
                <div className='accordion-header'>
                    <button type='button' onClick={() => accordionOnClick('Reassurance')}>
                        <h4>{titleLabel}</h4>
                        <div className={`accordion-button${isAccordionExpanded('Reassurance') ? ' -expanded' : ' -collapsed'}`}></div>
                    </button>
                </div>
                <div className={`content${isAccordionExpanded('Reassurance') ? ' -expanded' : ''}`}>
                    <div className='reassurance-container'>
                        {reassuranceItems.map((row: ReassuranceShowType, index: number) => {
                            const isLast = index === reassuranceItems.length - 1;
                            return (
                                <div className={`reassurance-row${!isLast ? ' -border' : ''}`}>
                                    <div className='reassurance-col -image'>
                                        <Image
                                            {...row.image}
                                            fallBackSrc=''
                                            altText=''
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={row.image.imageSettings}
                                            loadFailureBehavior='empty'
                                        />
                                    </div>
                                    <div className='reassurance-col -text'>
                                        <span className='title'>{row.title}</span>
                                        <span className='description'>{row.description}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    React.useEffect(() => {
        /* if (!fetchingLabels) {
            setFetchingLabels(true);
            _getProductLabels(productSku, productPrimaryImageUrl).then((response: string[]) => {
                const newProductLabels = [...productLabels];
                productLabels.forEach((_, index: number) => {
                    newProductLabels[index].imgLink = response[index];
                });
                setProductLabels(newProductLabels);
            });
        } */
    });

    if (temporaryDisabled) {
        return null;
    }

    return (
        <Module {...ProductSpecification}>
            {props.title}
            {pSpecifications.length ? (
                <Node className={'specifications_rows col-md-10 offset-md-1'}>
                    {// @ts-ignore
                    pSpecifications.map(row => {
                        const title = row.props.productName;
                        const titleId = title.replace(/\s+/g, '');
                        const titleLabel = labels[`product_specification_title_${title.replace(/\s+/g, '_').toLowerCase()}`] ?? title;
                        const ingredientsFinalString = ingredientsString;

                        let accordionContent;
                        if (title === 'Ingredients' && ingredientsFinalString) {
                            accordionContent = ingredientsFinalString;
                        } else if (title === 'Nutritional Values JSON') {
                            try {
                                const jData = JSON.parse(row.props.cellData.props.dangerouslySetInnerHTML.__html);
                                accordionContent = _renderNutritionalValues(jData);
                            } catch (e) {
                                return;
                            }
                        } else if (row.props.cellData.props.dangerouslySetInnerHTML.__html) {
                            accordionContent = row.props.cellData.props.dangerouslySetInnerHTML.__html;
                        }

                        if (!accordionContent) return;

                        return (
                            // tslint:disable-next-line:jsx-key
                            <div className={`${titleId} -accordion`}>
                                <div className='accordion-header'>
                                    <button type='button' onClick={() => accordionOnClick(titleId)}>
                                        <h4>{titleLabel}</h4>
                                        <div
                                            className={`accordion-button${isAccordionExpanded(titleId) ? ' -expanded' : ' -collapsed'}`}
                                        ></div>
                                    </button>
                                </div>
                                <div className={`content${isAccordionExpanded(titleId) ? ' -expanded' : ''}`}>{accordionContent}</div>
                            </div>
                        );
                    })}
                    {reassuranceItems.length > 0 ? _renderReassurance(reassuranceItems, labels) : null}
                    {/* {productLabels.filter(label => label.imgLink !== '').length > 0 ? _renderProductLabels(productLabels, labels) : null} */}
                    {/* { _renderSocialShare(props.slots && props.slots?.socialShare)} */}
                </Node>
            ) : (
                ''
            )}
        </Module>
    );
};

/* const _getProductLabels = async (productId?: string, baseImagePath?: string): Promise<string[]>  => {
    if (productId && baseImagePath) {
        const results: string[] = [];
        const imgBaseUrlArray = decodeURIComponent(baseImagePath).split('/');
        imgBaseUrlArray.pop();


        const imgUrls = [
            [...imgBaseUrlArray, `${productId}_000_006.jpg`].join('/'),
            [...imgBaseUrlArray, `${productId}_000_007.jpg`].join('/'),
            [...imgBaseUrlArray, `${productId}_000_008.jpg`].join('/'),
        ];
        
        for (let i=0; i<3; i=i+1) {
            try {
                const response = await axios.get(imgUrls[i]);
                results.push(response?.status === 200 ? imgUrls[i] : '');
            } catch (e) {
                results.push('');
            }
        }
        return results; 
    }
    return ['', '', ''];
} */

/* const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }
    return (
        <>
            {socialShare[0]}
        </>
    );
}; */

export default ProductSpecificationView;
